function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Validate from "../Validation/Validate";
import ChedioButtox from "./ChedioButtox";
export default class CheckBox extends Component {
  render() {
    const {
      checked,
      children,
      disabled,
      error,
      invalid,
      name,
      indeterminate,
      patterns,
      required,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(Validate, {
      error: error,
      patterns: patterns,
      required: required,
      value: checked
    }, isValid => /*#__PURE__*/React.createElement(ChedioButtox, _extends({}, rest, {
      checked: !!(checked || indeterminate),
      className: "ax-checkbox",
      disabled: disabled,
      indeterminate: indeterminate && !checked,
      inputType: "checkbox",
      invalid: invalid || isValid === false,
      name: name
    }), children));
  }

}